import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Loader, { showLoader } from "../components/loader";
import { apiUrl, appUrl } from "../utils/url";
import { useQuery } from "./walkthrough";
import { useSelector } from "react-redux";

const AppsumoCallback = () => {
    const history = useHistory();
    let query = useQuery();
    const code = query?.get('code');
    const { slug } = useSelector(state => state?.slugReducer);
    const projectSlug = slug ? slug : localStorage?.slug;
    const sendRequest = () => {

        const formData = new FormData();

        // for (const key in values) {
        //     if (Object.hasOwnProperty.call(values, key)) {
        //         formData.append(key, values[key]);
        //     }
        // }
        formData.append('code',code);
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formData,
            redirect: 'follow'
        };
        fetch(apiUrl + `/appsumo-callback`, requestOptions)
            .then(async (res) => {
                const response = await res?.json();
                if (response?.status_code == 200) {
                    toast.success(response?.status_message);
                } else {
                    toast.error(response?.status_message);
                }
                setTimeout(() => {
                    window.location.href= response?.data?.redirect_url;
                },200)
            })
            .catch((err) => {
                toast.error(err);
                setTimeout(() => {
                    window.location.href= response?.data?.redirect_url;
                },200)
                // history.push(localStorage.last_activity)
            })
    }

    useEffect(() => {
        if (code) {
            showLoader()
            sendRequest()
        }else {
            toast.error("Invalid Code");
            history.push('/project/'+ projectSlug + "/campaigns");
        }

    }, [])
    return <Loader />
}
export default AppsumoCallback